<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4" :type="'session'"></ContentLoader>
    </div>
    <div v-else>
      <!-- class="carouselContainer" -->
      <div v-if="trainerListData && trainerListData.length">
        <Carousel>
          <ul
            role="list"
            class="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8"
            v-for="d in trainerListData"
            :key="d.id"
          >
            <router-link
              :to="{ name: 'UserTrainerAbout', params: { trainer_id: d.id } }"
            >
              <li>
                <div class="space-y-4">
                  <div class="aspect-w-3 aspect-h-2">
                    <img
                      class="object-cover duration-500 shadow-all ring-1 ring-gray-darkest rounded-lg h-18 w-full"
                      :src="baseUrlSrc(d.thumbnail_url)"
                      alt=""
                      @error="defaultImage"
                    />
                  </div>

                  <div class="flex items-center justify-between">
                    <div
                      class="text-lg leading-6 font-semibold space-y-1 capitalize"
                    >
                      <h3>{{ d.name || "-" }}</h3>
                    </div>
                    <div class="flex items-center text-yellow-medium space-x-1">
                      <Star />
                      <p>{{ d.avg_rating || 0 }}</p>
                      <span class="text-gray-light text-sm">
                        {{ `(${d.total_reviews || 0})` }}
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </router-link>
          </ul>
        </Carousel>
      </div>
    </div>
    <div v-if="statusCode == 404">
      <div class="flex flex-col items-center justify-center px-4">
        <img
          :src="require(`@/assets/img/findSessionsNoData.svg`)"
          class="w-6/12 object-cover"
        />
        <div class="px-10 flex flex-col items-center justify-center">
          <p class="text-xl font-medium">
            There are no results that match your search
          </p>
          <p class="text-base text-gray-light">
            Please try adjusting your search keywords or filters.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import { Carousel } from "@/components/t-components";
import { Star } from "@/components/icons";

export default {
  name: "TrainerListCarousel",
  components: {
    Carousel,
    ContentLoader,
    Star,
  },
  props: {
    trainerListData: Array,
    statusCode: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
};
</script>

<style lang="scss" scoped>
.h-18 {
  height: 18rem;
}
</style>